// @flow
import React from 'react';
import Button from 'app/common/ui/Button';
import styles from './Message.scss';

type Props = {
  text: string,
  buttons: Array<Object>,
};

const Message = ({ text, buttons }: Props) =>
  <div className={styles.root}>
    <div className={styles.win}>
      {text.split('\n').map((str, i) =>
        <div key={i}>{str}</div>
      )}
      <div className={styles.buttons}>
        {buttons.map(props =>
          <Button {...props} />
        )}
      </div>
    </div>
  </div>;

export default Message;
